import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, HeartHandshake, Baby, Scale, CalendarHeart, GraduationCap, Receipt } from 'lucide-react';
import { CountrySelect } from '../components/family/shared';
import { ChildSupportForm } from '../components/family/ChildSupportForm';
import { CompensationForm } from '../components/family/CompensationForm';
import { VisitationForm } from '../components/family/VisitationForm';
import { PensionDebtForm } from '../components/family/PensionDebtForm';

const TABS = [
  { id: 'alimentos', label: 'Pensión de alimentos', icon: Baby, Comp: ChildSupportForm },
  { id: 'deuda', label: 'Deuda de pensiones', icon: Receipt, Comp: PensionDebtForm },
  { id: 'compensacion', label: 'Compensación económica', icon: Scale, Comp: CompensationForm },
  { id: 'visitas', label: 'Visitas y cuidado personal', icon: CalendarHeart, Comp: VisitationForm },
];

export default function FamilyHubPage() {
  const [country, setCountry] = useState('chile');
  const [tab, setTab] = useState('alimentos');
  const Active = TABS.find((t) => t.id === tab).Comp;

  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="family-hub-page">
      <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-4">
          <Link to="/dashboard" data-testid="family-back-btn" className="text-slate-400 hover:text-white transition-colors"><ArrowLeft className="h-5 w-5" /></Link>
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-rose-500/15"><HeartHandshake className="h-5 w-5 text-rose-400" /></div>
          <div>
            <h1 className="text-lg font-bold font-['Outfit']">Hub de Derecho de Familia</h1>
            <p className="text-xs text-slate-400">Calculadoras orientativas por país</p>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="w-full md:w-64">
            <span className="mb-1 block text-xs font-medium uppercase tracking-wider text-slate-400">País</span>
            <CountrySelect value={country} onChange={setCountry} testId="family-country-select" />
          </div>
          <Link to={`/agentes-especialistas?area=familia&country=${country}`} data-testid="family-ask-agent-btn"
            className="inline-flex items-center gap-2 self-start rounded-full border border-rose-500/50 px-5 py-2 text-sm font-semibold text-rose-200 hover:bg-rose-500/10 transition-colors">
            <GraduationCap className="h-4 w-4" /> Consultar al socio de Familia IA
          </Link>
        </div>
        <div className="mb-6 flex flex-wrap gap-2" role="tablist">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button key={id} role="tab" aria-selected={tab === id} data-testid={`family-tab-${id}`} onClick={() => setTab(id)}
              className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${tab === id ? 'border-rose-400 bg-rose-500 text-white' : 'border-slate-700 text-slate-300 hover:bg-slate-800'}`}>
              <Icon className="h-4 w-4" /> {label}
            </button>
          ))}
        </div>
        <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-5 md:p-8">
          <Active key={`${tab}-${country}`} country={country} />
        </section>
      </main>
    </div>
  );
}
